import CategoriesItemTops from "./CategoriesItemTops.jsx";
import Footer from "../Footer.jsx";
import Newsletter from "../Newsletter.jsx";

function Hoodies() {
  return (
    <>
      <CategoriesItemTops />
      <Newsletter />
      <Footer />
    </>
  );
}

export default Hoodies;
